import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dumbbell, Sparkles, Waves, GlassWater, Utensils, Bell, Activity, Sun, ArrowRight } from "lucide-react";
import GuestHeader from "@/components/GuestHeader";
import { api } from "@/lib/api";
import { getGuest } from "@/lib/guest";

const icons = { sparkles: Sparkles, dumbbell: Dumbbell, waves: Waves, "glass-water": GlassWater, utensils: Utensils, bell: Bell, activity: Activity, sun: Sun };
const catNames = { wellness: "Wellness", fitness: "Fitness", leisure: "Leisure", dining: "Dining & Service", service: "Guest Services" };

export default function GuestExperienceHub() {
  const navigate = useNavigate();
  const guest = getGuest() || {};
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/public/modules").then((r) => setItems(r.data?.items || [])).catch(() => setItems([])).finally(() => setLoading(false)); }, []);
  const groups = useMemo(() => {
    const out = {};
    for (const item of items.filter(m => m.engine !== "chat")) (out[item.category] ||= []).push(item);
    return out;
  }, [items]);

  const open = (m) => m.id === "spa" ? navigate("/menu") : navigate(`/service/${m.id}`);

  return (
    <div className="min-h-screen bg-background">
      <GuestHeader guestName={guest.name} />
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-8">
        <div className="overline text-accent mb-5">SLX-one</div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight leading-[1.03]">Your experience,<br/><em className="text-accent font-normal">one touch away.</em></h1>
        <p className="mt-6 max-w-xl text-muted-foreground text-lg">Welcome, {guest.name || "Guest"}. Only the services currently available aboard are shown here.</p>
      </section>
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-20 space-y-10">
        {loading && <div className="text-muted-foreground">Preparing your onboard services…</div>}
        {!loading && Object.keys(groups).length === 0 && <div className="border border-border bg-card p-8 text-muted-foreground">Guest services are being prepared. Please check again shortly.</div>}
        {Object.entries(groups).map(([cat, mods]) => (
          <div key={cat}>
            <div className="overline text-primary/50 mb-3">{catNames[cat] || cat}</div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {mods.map((m) => {
                const Icon = icons[m.icon] || Sparkles;
                return <button key={m.id} onClick={() => open(m)} className="group text-left border border-border bg-card p-6 min-h-[180px] hover:border-accent/60 hover:-translate-y-0.5 transition-all">
                  <div className="flex items-start justify-between"><Icon className="h-6 w-6 text-accent" strokeWidth={1.4}/><ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-accent transition-colors"/></div>
                  <div className="font-display text-2xl mt-8">{m.name}</div>
                  <div className="text-sm text-muted-foreground mt-2 line-clamp-2">{m.description}</div>
                </button>;
              })}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
